<form [formGroup]="form" (ngSubmit)="onFormSubmit()"> 
  
    <div *ngIf="errorMessage" class="alert alert-danger">
        {{ errorMessage | translate }}
    </div>
    <div>
        <p class="forgET">{{'FORGOT_PASSWORD' | translate}}</p>
    </div>
    <div class="form-group">
        <label for="login-input-email">{{'EMAIL' | translate}}*</label>
        <input closs="Upper_low" autocomplete="off" type="text"
            [ngClass]="!form.get('email')?.valid && form.get('email')?.touched ? 'input-field errorInp' : 'input-field' "
            id="login-input-email" [placeholder]="'EMAIL' | translate" formControlName="email" (focus)="onInputFocus()" (keypress)="emailValid($event)">
        <small class="error fielderror" *ngIf="!form.get('email')?.valid && form.get('email')?.touched">
            <span *ngIf="form.get('email')?.errors?.['required']">  {{ 'EMAIL_REQUIRED' | translate }}</span>
                      <span *ngIf="form.get('email')?.errors?.['pattern']">     {{ 'EMAIL_INVALID' | translate }}</span>
                      
        </small>
    </div>
    <div class="form-group">
        <label for="login-input-loginname">{{'USERNAME' | translate}}*</label>

        <input autocomplete="off"
            [ngClass]="!form.get('login')?.valid && form.get('login')?.touched ? 'input-field errorInp' : 'input-field' "
            type="text" id="login-input-login" formControlName="login" id="login-input-loginname"
            (focus)="onInputFocus()" [placeholder]="'USERNAME' | translate" (keypress)="userNameValid($event)">


        <small class="error fielderror" *ngIf="!form.get('login')?.valid && form.get('login')?.touched">
            <span *ngIf="form.get('login')?.errors?.['required']">
                {{ 'USERNAME_REQUIRED' | translate }}
            </span>
            <span *ngIf="form.get('login')?.errors?.['minlength'] || form.get('login')?.errors?.['maxlength']">
                {{ 'USERNAME_LENGTH' | translate }}
            </span>
             
            <span *ngIf="form.get('login')?.errors?.['pattern']">
                {{ 'USERNAME_PATTERN' | translate }}
            </span>

 
        </small>
    </div>
    <div class="form-group">
        <button type="submit" class="submit-btn" [disabled]="form.invalid">{{'SUBMIT' | translate}}</button>
    </div>
</form>

 